import {Table} from 'react-bootstrap';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh } from '../SortableTable';
import { formatDateTime } from '../../utils/dateFormat';

const LOG_SORT_COLUMNS = {
    when: { type: 'date', value: (l) => l?.createdAt },
    detail: { type: 'string', value: (l) => l?.text },
    role: { type: 'string', value: (l) => (l?.doctor_id || l?.hr_id || l?.admin_id || l?.created_by || {}).role },
};

const LoginLogoutLogType = ({reportBy, logType, logs}) => {
  const tableSort = useSortableTable(logs, { id: 'logs.LoginLogoutLogType', columns: LOG_SORT_COLUMNS, defaultSort: { key: 'when', dir: 'desc' } });

  return (
    <div>
        <Table striped hover>
                <thead align="center">
                    <tr>
                        <th>Name</th>
                        <SortableTh sortKey="role" sort={tableSort}>Role</SortableTh>
                        <SortableTh sortKey="detail" sort={tableSort}>Details</SortableTh>
                        <th>{reportBy === 'doctor' ? "License Number" : "Email Address"}</th>
                        <SortableTh sortKey="when" sort={tableSort}>Date & Time</SortableTh>
                    </tr> 
                </thead>
                <tbody>
                {tableSort.rows.map((log, index) => (
                <tr key={index}>
                    {reportBy === 'doctor' && logType === 'logs' ? <>
                        <td>{formatClinicianName(log?.doctor_id)}
                        </td>
                        <td>{log?.doctor_id?.role}</td>
                        <td>{log?.text}</td>
                        <td>{log?.doctor_id?.licensenumber}</td>
                        <td>{formatDateTime(log?.createdAt)}</td>
                    </> : <>
                        <td>{log?.hr_id?.lastname} {log?.hr_id?.firstname}
                        </td>
                        <td>{log?.hr_id?.role}</td>
                        <td>{log?.text}</td>
                        <td>{log?.hr_id?.email}</td>
                        <td>{formatDateTime(log?.createdAt)}</td>
                    </>}
                </tr>
                ))}
            </tbody>
        </Table>
    </div>
  )
}

export default LoginLogoutLogType